<template>
  <div class="page_main">
    <div class="layout">
      <div class="time">{{ time }}</div>
      <div class="top_title">叉车物联网管理平台</div>
      <div class="main_content">
        <div class="left">
          <div class="six_month_box">
            <div class="title_box">
              <div class="title_label">近六月企业趋势</div>
              <!-- <div class="more" @click="lookMore('近六月企业趋势')">
                更多
                <img class="icon" src="@/assets/image/arrow.png" alt="" />
              </div> -->
            </div>
            <div class="six_charts" id="sixChart"></div>
          </div>
          <div class="six_month_box">
            <div class="title_box">
              <div class="title_label">近六月车辆趋势</div>
              <!-- <div class="more" @click="lookMore('近六月车辆趋势')">
                更多
                <img class="icon" src="@/assets/image/arrow.png" alt="" />
              </div> -->
            </div>
            <div class="six_charts" id="sixCarChart"></div>
          </div>
          <div class="car_num_sort">
            <div class="title_box">
              <div class="title_label">车辆数排名</div>
              <!-- <div class="more" @click="lookMore('车辆数排名')">
                更多
                <img class="icon" src="@/assets/image/arrow.png" alt="" />
              </div> -->
            </div>
            <div class="tabs_box">
              <div
                :class="current == index ? 'tabs_list active' : 'tabs_list'"
                v-for="(item, index) in tabs"
                :key="index"
                @click="tabsChange(index)"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="car_num_list_box">
              <div class="swiper-wrapper">
                <div
                  class="list_box swiper-slide"
                  v-for="(item, index) in carSortList"
                  :key="index"
                >
                  <div class="list">
                    <div class="icon">{{ index + 1 }}</div>
                    <div class="list_top">
                      <div class="text">{{ item.companyName }}</div>
                      <div class="text">车辆数量：{{ item.count }}台</div>
                    </div>
                    <div class="porcess_box">
                      <div class="process_line" :style="'width: ' + 30 + '%'"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="center">
          <div class="num_info_box">
            <div class="num_list n1">
              <img class="icon" src="@/assets/image/i1.png" alt="" />
              <div class="label">企业数量</div>
              <div class="num">{{ baseInfo.companyCount }}</div>
            </div>
            <div class="num_list n2">
              <img class="icon" src="@/assets/image/i2.png" alt="" />
              <div class="label">车辆数量</div>
              <div class="num">{{ baseInfo.carCount }}</div>
            </div>
            <div class="num_list n3">
              <img class="icon" src="@/assets/image/i3.png" alt="" />
              <div class="label">驾驶员数量</div>
              <div class="num">{{ baseInfo.driverCount }}</div>
            </div>
          </div>
          <div class="map_box">
            <div
              class="back"
              v-if="currentLevel === 'city'"
              @click="backToProvince"
            ></div>
            <div class="map_content" id="map"></div>
          </div>
          <div class="car_status_box">
            <div class="status_list">
              <div class="icon_box">
                <img class="icon" src="@/assets/image/s2.png" alt="" />
              </div>
              <div class="label">车辆总数</div>
            </div>
            <div class="status_list">
              <div class="icon_box">
                <img class="icon" src="@/assets/image/s1.png" alt="" />
              </div>
              <div class="label">在线车辆</div>
            </div>
            <div class="status_list">
              <div class="icon_box">
                <img class="icon" src="@/assets/image/s3.png" alt="" />
              </div>
              <div class="label">离线车辆</div>
            </div>
            <div class="status_num">{{ carStatus.carCount }}</div>
            <div class="status_num">{{ carStatus.onlineCount }}</div>
            <div class="status_num">{{ carStatus.offlineCount }}</div>
          </div>
        </div>
        <div class="right">
          <div class="warn_sort">
            <div class="title_box">
              <div class="title_label">证书预警排名</div>
              <div class="more" @click="lookMore('证书预警排名')">
                更多
                <img class="icon" src="@/assets/image/arrow.png" alt="" />
              </div>
            </div>
            <div class="worn_sort_content">
              <div class="list">
                <div class="sort_icon_box">
                  <img class="icon" src="@/assets/image/w1.png" alt="" />
                </div>
                <div class="sort_desc_box">
                  <div class="label">车辆年检过期数量</div>
                  <div class="num">{{ baseInfo.expiredCarCount }}</div>
                </div>
              </div>
              <div class="list">
                <div class="sort_icon_box">
                  <img class="icon" src="@/assets/image/w2.png" alt="" />
                </div>
                <div class="sort_desc_box">
                  <div class="label">驾驶员证书过期数量</div>
                  <div class="num">{{ baseInfo.expiredDriverCount }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="warn_record">
            <div class="title_box">
              <div class="title_label">预警记录</div>
              <div class="more" @click="lookMore('预警记录')">
                更多
                <img class="icon" src="@/assets/image/arrow.png" alt="" />
              </div>
            </div>
            <div class="record_box">
              <div class="swiper-wrapper">
                <div
                  class="record_list swiper-slide"
                  v-for="(item, index) in warnList"
                  :key="index"
                >
                  <div class="list">
                    <div class="title">
                      <div class="label">{{ item.subjectName }}</div>
                    </div>
                    <div class="desc">
                      <img class="photo" src="@/assets/image/r1.png" alt="" />
                      <div class="info_box">
                        <div class="name">{{ item.companyName }}</div>
                        <div class="time">{{ item.eventTime }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="warn_any">
            <div class="title_box">
              <div class="title_label">预警统计</div>
              <!-- <div class="more" @click="lookMore('预警统计')">
                更多
                <img class="icon" src="@/assets/image/arrow.png" alt="" />
              </div> -->
            </div>
            <div class="tabs_box">
              <!-- <div
                :class="currentWarn == index ? 'tabs_list active' : 'tabs_list'"
                v-for="(item, index) in tabsWarn"
                :key="index"
                @click="tabsChangeWarn(index)"
              >
                {{ item.name }}
              </div> -->
            </div>
            <div class="charts" id="warn_charts"></div>
          </div>
        </div>
      </div>
    </div>
    <MaskTable ref="mask" />
  </div>
</template>

<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import * as echarts from "echarts";
import MaskTable from "./maskTable";
import {
  getCompanyList,
  getCarList,
  getBaseInfo,
  getCarSortList,
  getCarStatus,
  getWarnList,
  getWarnAnay,
  getCityList,
  getAreaList,
} from "@/api/user";

import hubeiGeoJson from "@/utils/map.json"; // 湖北省geojson
// 市区geojson示例引入写法（实际建议动态import或按需加载）
import shiyan from "@/utils/cities/shiyan.json";
import shennongjia from "@/utils/cities/shennongjia.json";
import enshi from "@/utils/cities/enshi.json";
import xiangyang from "@/utils/cities/xiangyang.json";
import yichang from "@/utils/cities/yichang.json";
import suizhou from "@/utils/cities/suizhou.json";
import jingmen from "@/utils/cities/jingmen.json";
import jingzhou from "@/utils/cities/jingzhou.json";
import xiaogan from "@/utils/cities/xiaogan.json";
import tianmen from "@/utils/cities/tianmen.json";
import qianjiang from "@/utils/cities/qianjiang.json";
import xiantao from "@/utils/cities/xiantao.json";
import wuhan from "@/utils/cities/wuhan.json";
import huanggang from "@/utils/cities/huanggang.json";
import ezhou from "@/utils/cities/ezhou.json";
import huangshi from "@/utils/cities/huangshi.json";
import xianning from "@/utils/cities/xianning.json";

export default {
  name: "IndexHome",
  components: {
    MaskTable,
  },
  data() {
    return {
      time: "",
      tabs: [
        { name: "车辆数倒序", code: "1" },
        { name: "车辆数顺序", code: "2" },
      ],
      current: 0,
      // tabsWarn: [
      //   { name: "今日", code: "1" },
      //   { name: "本月", code: "2" },
      //   { name: "本年", code: "2" },
      // ],
      currentWarn: 0,
      warnList: [],
      currentLevel: "province", // 省级或市级
      currentMapName: "hubei", // 当前注册的地图名称

      companyList: [],
      carList: [],
      baseInfo: {},
      carSortList: [],
      carStatus: {},
      warnAnayList: [],
    };
  },

  mounted() {
    this.getTime();
    this.initMap();

    this.getCompany();
    this.getCar();
    this.getBase();
    this.getCarSort();
    this.getStatus();
    this.getWarn();
    this.getAnay();
  },

  methods: {
    getWarn() {
      getWarnList().then((res) => {
        this.warnList = res.data;
        this.$nextTick(() => {
          this.swiperInitWarn();
        });
      });
    },
    lookMore(type) {
      // 近六月企业趋势
      // 近六月车辆趋势
      // 车辆数排名
      // 证书预警排名
      // 预警记录
      // 预警统计
      // if (type == "预警记录") {
      this.$refs.mask.open(type);
      // }
    },
    tabsChange(index) {
      if (this.current != index) {
        this.carSortList.reverse();
      }
      this.current = index;
    },
    tabsChangeWarn(index) {
      this.currentWarn = index;
    },
    swiperInitWarn() {
      new Swiper(".record_box", {
        slidesPerView: "2",
        loop: true, // 循环模式选项
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        spaceBetween: 0,
      });
    },
    swiperInitCarNum() {
      new Swiper(".car_num_list_box", {
        slidesPerView: "3",
        loop: true, // 循环模式选项
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        spaceBetween: 0,
      });
    },
    initMap(mapName = "hubei", geoJson = hubeiGeoJson, mapTitle = "湖北省") {
      const myChart = echarts.init(document.getElementById("map"));
      this.myChart = myChart;
      echarts.registerMap(mapName, geoJson);
      if (this.currentLevel == "province") {
        getCityList().then((res) => {
          const cityData = res.data;
          const option = {
            title: {
              text: mapTitle,
              left: "center",
              textStyle: {
                color: "#fff", // 这里设置你想要的颜色，比如橙色
                fontSize: 18, // 也可以设置字体大小
                fontWeight: "bold", // 加粗（可选）
              },
            },
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                if (params.value) return `${params.name}: ${params.value}`;
                return params.name;
              },
            },
            series: [
              {
                name: mapTitle,
                type: "map",
                map: mapName,
                roam: false,
                zoom: 1.15,
                label: { show: true },
                itemStyle: {
                  areaColor: "#8FB8D6",
                  borderColor: "#404a59",
                },
                emphasis: {
                  label: { show: true, color: "#fff", fontWeight: "bold" },
                  itemStyle: { areaColor: "#f0a31a" },
                },
                data: cityData,
              },
            ],
          };
          myChart.setOption(option);
          // 点击事件，切换市区地图
          myChart.off("click");
          myChart.on("click", (params) => {
            if (this.currentLevel === "province") {
              const cityName = params.name;
              this.loadCityMap(cityName);
            }
          });
        });
      } else {
        getAreaList().then((res) => {
          const cityData = res.data;
          const option = {
            title: {
              text: mapTitle,
              left: "center",
              textStyle: {
                color: "#fff", // 这里设置你想要的颜色，比如橙色
                fontSize: 18, // 也可以设置字体大小
                fontWeight: "bold", // 加粗（可选）
              },
            },
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                if (params.value) return `${params.name}: ${params.value}`;
                return params.name;
              },
            },
            series: [
              {
                name: mapTitle,
                type: "map",
                map: mapName,
                roam: false,
                zoom: 1.15,
                label: { show: true },
                itemStyle: {
                  areaColor: "#8FB8D6",
                  borderColor: "#404a59",
                },
                emphasis: {
                  label: { show: true, color: "#fff", fontWeight: "bold" },
                  itemStyle: { areaColor: "#f0a31a" },
                },
                data: cityData,
              },
            ],
          };
          myChart.setOption(option);
          // 点击事件，切换市区地图
          myChart.off("click");
          myChart.on("click", (params) => {
            if (this.currentLevel === "province") {
              const cityName = params.name;
              this.loadCityMap(cityName);
            }
          });
        });
      }
    },
    loadCityMap(cityName) {
      console.log(cityName, "cityNamecityNamecityName");
      // 市名转拼音映射（示例，建议完善）
      const cityMap = {
        十堰市: { mapName: "shiyan", geoJson: shiyan },
        神农架林区: { mapName: "shennongjia", geoJson: shennongjia },
        恩施土家族苗族自治州: { mapName: "enshi", geoJson: enshi },
        襄阳市: { mapName: "xiangyang", geoJson: xiangyang },
        宜昌市: { mapName: "yichang", geoJson: yichang },
        随州市: { mapName: "suizhou", geoJson: suizhou },
        荆门市: { mapName: "jingmen", geoJson: jingmen },
        荆州市: { mapName: "jingzhou", geoJson: jingzhou },
        孝感市: { mapName: "xiaogan", geoJson: xiaogan },
        天门市: { mapName: "tianmen", geoJson: tianmen },
        潜江市: { mapName: "qianjiang", geoJson: qianjiang },
        仙桃市: { mapName: "xiantao", geoJson: xiantao },
        武汉市: { mapName: "wuhan", geoJson: wuhan },
        黄冈市: { mapName: "huanggang", geoJson: huanggang },
        鄂州市: { mapName: "ezhou", geoJson: ezhou },
        黄石市: { mapName: "huangshi", geoJson: huangshi },
        咸宁市: { mapName: "xianning", geoJson: xianning },
        // 其他市对应json要补充
      };
      const city = cityMap[cityName];
      if (!city) {
        alert("未找到该市的地图数据！");
        return;
      }
      this.currentLevel = "city";
      this.currentMapName = city.mapName;
      this.myChart.dispose(); // 销毁原图实例
      this.initMap(city.mapName, city.geoJson, cityName); // 传入市区地图参数
    },
    backToProvince() {
      if (this.currentLevel === "city") {
        this.currentLevel = "province";
        this.currentMapName = "hubei";
        this.myChart.dispose();
        this.initMap("hubei", hubeiGeoJson, "湖北省");
      }
    },
    initWarnCharts() {
      const myChart = echarts.init(document.getElementById("warn_charts"));
      const option = {
        tooltip: {
          trigger: "item",
          // formatter: "{b}",
        },
        legend: {
          orient: "vertical",
          right: 10,
          top: "middle",
          textStyle: {
            color: "#fff",
          },
        },
        color: ["#3fa7ff", "#7a6ff0", "#4de2d0", "#f2637b", "#ffe29a", "#fbb03b"],
        series: [
          {
            name: "告警占比",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["40%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: this.warnAnayList,
          },
        ],
      };
      myChart.setOption(option);
    },
    initSixCharts() {
      const myChart = echarts.init(document.getElementById("sixChart"));
      const option = {
        grid: {
          top: 30,
          bottom: 20,
          left: 25,
          right: 30,
          containLabel: true, // 保证坐标轴标签显示完整
        },
        backgroundColor: "rgba(0,0,0,0)", // 设置背景透明
        tooltip: {
          trigger: "axis",
          backgroundColor: "#1c1c3c",
          borderColor: "#61dafb",
          borderWidth: 1,
          textStyle: {
            color: "#fff",
          },
          formatter: (params) => {
            let data = params[0];
            return `${data.axisValue}<br/> ● 企业数量：${data.data}`;
          },
        },
        xAxis: {
          type: "category",
          data: this.companyList.map((item) => {
            return item.month;
          }),
          axisLine: {
            lineStyle: {
              color: "#ccc",
            },
          },
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#ccc",
            },
          },
          axisLabel: {
            color: "#fff",
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#444",
            },
          },
        },
        series: [
          {
            name: "企业数量",
            type: "line",
            smooth: true,
            data: this.companyList.map((item) => {
              return item.count;
            }),
            symbol: "circle",
            symbolSize: 6,
            itemStyle: {
              color: "#4dd0e1",
            },
            lineStyle: {
              color: "#4dd0e1",
              width: 3,
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    initSixCarCharts() {
      const myChart = echarts.init(document.getElementById("sixCarChart"));
      const option = {
        grid: {
          top: 30,
          bottom: 20,
          left: 25,
          right: 30,
          containLabel: true, // 保证坐标轴标签显示完整
        },
        backgroundColor: "rgba(0,0,0,0)", // 设置背景透明
        tooltip: {
          trigger: "axis",
          backgroundColor: "#1c1c3c",
          borderColor: "#61dafb",
          borderWidth: 1,
          textStyle: {
            color: "#fff",
          },
          formatter: (params) => {
            let data = params[0];
            return `${data.axisValue}<br/> ● 企业数量：${data.data}`;
          },
        },
        xAxis: {
          type: "category",
          data: this.carList.map((item) => {
            return item.month;
          }),
          axisLine: {
            lineStyle: {
              color: "#ccc",
            },
          },
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#ccc",
            },
          },
          axisLabel: {
            color: "#fff",
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#444",
            },
          },
        },
        series: [
          {
            name: "车辆数量",
            type: "line",
            smooth: true,
            data: this.carList.map((item) => {
              return item.count;
            }),
            symbol: "circle",
            symbolSize: 6,
            itemStyle: {
              color: "#FFB91D",
            },
            lineStyle: {
              color: "#FFB91D",
              width: 3,
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      // 根据本地化格式输出日期（中文）
      const localeFormattedDate = date.toLocaleString("zh-CN");
      return localeFormattedDate;
    },
    getTime() {
      this.getCurrentDateTime();
      setInterval(() => {
        this.getCurrentDateTime();
      }, 1000);
    },
    getCurrentDateTime() {
      let now = new Date();
      // 获取日期部分
      let year = now.getFullYear();
      let month = (now.getMonth() + 1).toString().padStart(2, "0"); // 月份从0开始，所以要+1
      let day = now.getDate().toString().padStart(2, "0");
      // 获取时间部分
      let hours = now.getHours().toString().padStart(2, "0");
      let minutes = now.getMinutes().toString().padStart(2, "0");
      let seconds = now.getSeconds().toString().padStart(2, "0");
      // 获取星期部分
      let weekDays = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      let weekDay = weekDays[now.getDay()];
      // 组合成目标格式
      this.time = `${year}.${month}.${day} ${hours}:${minutes}:${seconds} ${weekDay}`;
    },
    getCompany() {
      getCompanyList().then((res) => {
        this.companyList = res.data;
        this.initSixCharts();
      });
    },
    getCar() {
      getCarList().then((res) => {
        this.carList = res.data;
        this.initSixCarCharts();
      });
    },
    getBase() {
      getBaseInfo().then((res) => {
        this.baseInfo = res.data;
      });
    },
    getCarSort() {
      getCarSortList().then((res) => {
        this.carSortList = res.data;
        this.$nextTick(() => {
          this.swiperInitCarNum();
        });
      });
    },
    getStatus() {
      getCarStatus().then((res) => {
        this.carStatus = res.data;
      });
    },
    getAnay() {
      getWarnAnay().then((res) => {
        this.warnAnayList = res.data;
        this.initWarnCharts();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.page_main {
  // width: 1720px;
  // height: 1032px;
  position: relative;
  width: 100%;
  height: 98.2vh;
}
.layout {
  width: 97.68%;
  height: 97.68%;
  padding: 1.16%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: url("@/assets/image/big_bg.png") no-repeat center;
  background-size: 100% 100%;
  .time {
    width: 100%;
    text-align: left;
    font-weight: 700;
    font-size: 18px;
    color: #fff;
    height: 2.3%;
    line-height: 24px;
  }
  .top_title {
    background: url("@/assets/image/top_title.png") no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    height: 6.2%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 40px;
    color: #fff;
    letter-spacing: 4px;
    text-shadow: 0px 10px 8px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .main_content {
    width: 100%;
    height: 92.83%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .left {
      height: 100%;
      width: 25%;
      .six_month_box {
        margin-bottom: 3%;
        width: 100%;
        height: 29%;
        background: url("@/assets/image/box_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        .title_box {
          height: 14.28%;
        }
        .six_charts {
          width: 100%;
          height: calc(100% - 14.28%);
        }
      }
      .car_num_sort {
        margin-bottom: 3%;
        width: 100%;
        height: 38.5%;
        background: url("@/assets/image/box_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        .title_box {
          height: 11.83%;
        }
        .tabs_box {
          margin: 10px auto 20px;
          height: 7.1%;
          width: 90.7%;
          display: flex;
          align-content: center;
          justify-content: flex-start;
          .tabs_list:last-child {
            margin-left: 20px;
          }
          .tabs_list {
            background: url("@/assets/image/tab.png") no-repeat center;
            background-size: 100% 100%;
            width: 22.05%;
            height: 100%;
            font-weight: 700;
            font-size: 12px;
            color: #fff;
            text-align: center;
            line-height: 24px;
            cursor: pointer;
            &.active {
              font-weight: 400;
              background: url("@/assets/image/tab_a.png") no-repeat center;
              background-size: 100% 100%;
            }
          }
        }
        .car_num_list_box {
          width: 90.7%;
          // height: 74px;
          margin: auto;
          height: calc(100% - 100px);
          overflow: hidden;

          .list_box {
            width: 100%;
            border-radius: 10px;
            overflow: hidden;
          }
          .list {
            width: 100%;
            height: 92%;
            background: rgba(34, 148, 255, 0.08);
            border-radius: 10px;
            border: 1px solid;
            border-image: linear-gradient(
                180deg,
                rgba(0, 166.00000530481339, 255, 0),
                rgba(0, 166.00000530481339, 255, 0.20000000298023224)
              )
              1 1;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .icon {
              width: 40px;
              height: 24px;
              position: absolute;
              margin: auto;
              left: 0;
              top: 0;
              text-align: center;
              line-height: 24px;
              font-size: 14px;
              color: #fff;
              background: url("@/assets/image/car_num_icon.png") no-repeat center;
              background-size: 100% 100%;
            }
            .list_top {
              width: 340px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .text {
                font-weight: 400;
                font-size: 14px;
                color: #fff;
              }
            }
            .porcess_box {
              width: 340px;
              margin-top: 5px;
              height: 6px;
              background: rgba(47, 203, 255, 0.1);
              border-radius: 5px;

              .process_line {
                height: 100%;
                background: linear-gradient(270deg, #2fcbff 0%, #00ffe3 100%);
                border-radius: 5px;
              }
            }
          }
        }
      }
    }
    .center {
      width: 50%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .num_info_box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 3.83%;
        .num_list {
          width: 28.29%;
          height: 100%;
          display: flex;
          align-items: center;
          .icon {
            height: 72.2%;
            margin-left: 8.62%;
          }
          .label {
            font-weight: 700;
            font-size: 18px;
            color: #fff;
            flex: 1;
          }
          .num {
            font-weight: 700;
            font-size: 26px;
            color: #fff;
            margin-right: 20.26%;
          }
          &.n1 {
            background: url("@/assets/image/n1.png") no-repeat center;
            background-size: 100% 100%;
          }
          &.n2 {
            background: url("@/assets/image/n2.png") no-repeat center;
            background-size: 100% 100%;
          }
          &.n3 {
            background: url("@/assets/image/n3.png") no-repeat center;
            background-size: 100% 100%;
          }
        }
      }
      .map_box {
        width: 97%;
        height: 75%;
        position: relative;
        .back {
          position: absolute;
          margin: auto;
          cursor: pointer;
          left: 0;
          top: 0;
          background: url("@/assets/image/back.png") no-repeat center;
          background-size: 100% 100%;
          width: 124px;
          height: 36px;
          z-index: 999;
        }
        .map_content {
          width: 100%;
          height: 100%;
        }
      }
      .car_status_box {
        width: 58.54%;
        height: 12.14%;
        background: rgba(1, 17, 32, 0.8);
        border: 1px solid;
        border-image: linear-gradient(
            137deg,
            rgba(173.76105844974518, 218.54664087295532, 255, 0.27000001072883606),
            rgba(63.185840472579, 168.92957210540771, 255, 0.7200000286102295)
          )
          1 1;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-wrap: wrap;
        .status_list {
          width: 25.5%;
          height: 31.6%;
          background: url("@/assets/image/status_bg.png") no-repeat center;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          .icon_box {
            height: 100%; /* 例如，100px */
            aspect-ratio: 1 / 1;
            display: flex;
            align-items: center;
            justify-content: center;
            .icon {
              height: 50%;
              width: 50%;
            }
          }
          .label {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 16px;
            color: #fff;
          }
        }
        .status_num {
          width: 25%;
          padding-left: 5%;
          height: 31.6%;
          font-weight: 700;
          font-size: 26px;
          color: #00eeff;
          text-align: left;
        }
      }
    }
    .right {
      height: 100%;
      width: 25%;
      .warn_sort {
        margin-bottom: 3%;
        width: 100%;
        height: 29%;
        background: url("@/assets/image/box_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        .title_box {
          height: 14.28%;
        }
        .worn_sort_content {
          margin: auto;
          height: 77.14%;
          width: 90.7%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .list {
            width: 44.87%;
            height: 100%;
            background: url("@/assets/image/warn_bg.png") no-repeat center;
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            .sort_icon_box {
              height: 67%;
              width: 100%;
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              .icon {
                // margin-top: 18.98%;
                margin-top: 5%;
                width: 45.7%;
                aspect-ratio: 1 / 1;
              }
            }
            .sort_desc_box {
              height: 33%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-evenly;
              .label {
                // margin-top: 14.35%;
                font-weight: 400;
                font-size: 14px;
                color: #c8b895;
              }
              .num {
                font-weight: 700;
                font-size: 24px;
                margin-top: 3%;
                color: #ffedc4;
              }
            }
          }
        }
      }
      .warn_record {
        margin-bottom: 3%;
        width: 100%;
        height: 29%;
        background: url("@/assets/image/box_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        .title_box {
          height: 14.28%;
        }
        .record_box {
          width: 90.7%;
          height: 75%;
          overflow: hidden;
          margin: auto;
          .list {
            height: 92%;
            width: 100%;
            border-radius: 10px;
            border: 1px solid;
            background: rgba(255, 103, 103, 0.08);
            border-image: linear-gradient(
                180deg,
                rgba(245.89286148548126, 42.43283987045288, 42.43283987045288, 0),
                rgba(
                  245.89286148548126,
                  42.43283987045288,
                  42.43283987045288,
                  0.10000000149011612
                )
              )
              1 1;
            .title {
              background: url("@/assets/image/record_bg.png") no-repeat center;
              background-size: 100% 100%;
              display: flex;
              height: 34%;
              width: 100%;
              align-items: center;
              justify-content: flex-start;
              .label {
                padding-left: 5.13%;
                font-weight: 700;
                font-size: 16px;
                color: #fff;
              }
            }
            .desc {
              height: 66%;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              .photo {
                width: 12.82%;
                height: 70%;
                margin-left: 5.38%;
              }
              .info_box {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                margin-left: 2.7%;
                .name {
                  font-weight: 400;
                  font-size: 16px;
                  color: #fff;
                }
                .time {
                  font-weight: 400;
                  font-size: 14px;
                  color: #fff;
                }
              }
            }
          }
        }
      }
      .warn_any {
        margin-bottom: 3%;
        width: 100%;
        height: 38.5%;
        background: url("@/assets/image/box_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        .title_box {
          height: 11.83%;
        }
        .tabs_box {
          margin: 10px auto 20px;
          height: 7.1%;
          width: 90.7%;
          display: flex;
          align-content: center;
          justify-content: flex-start;
          .tabs_list:first-child {
            margin-left: 0;
          }
          .tabs_list {
            background: url("@/assets/image/wt.png") no-repeat center;
            background-size: 100% 100%;
            width: 16.41%;
            height: 100%;
            font-weight: 700;
            margin-left: 20px;
            font-size: 12px;
            color: #fff;
            text-align: center;
            line-height: 24px;
            cursor: pointer;
            &.active {
              font-weight: 400;
              background: url("@/assets/image/wt-a.png") no-repeat center;
              background-size: 100% 100%;
            }
          }
        }
        .charts {
          height: 73%;
          width: 100%;
        }
      }
    }
  }
}
.title_box {
  width: 100%;
  background: url("@/assets/image/title_bg.png") no-repeat center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title_label {
    font-family: YouSheBiaoTiHei;
    margin-left: 40px;
    font-weight: 400;
    font-size: 24px;
    color: #fff;
    letter-spacing: 2px;
    text-align: left;
    line-height: 31px;
    flex: 1;
  }
  .more {
    height: 100%;
    font-weight: 400;
    font-size: 16px;
    color: #f98901;
    letter-spacing: 1px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    padding-right: 4.65%;
    cursor: pointer;
    .icon {
      height: 45%;
    }
  }
}
</style>
